import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import PerformanceReviewQuestion from './PerformanceReviewQuestion';

class PerformanceReviewTemplate extends DomainObject {
  name;
  questions = [];
  questionCount;

  _relations = {
    questions: [PerformanceReviewQuestion]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      questions: observable,
      questionCount: observable
    });

    this.merge(other);
  }
}

export default PerformanceReviewTemplate;

